module.exports = __webpack_public_path__ + "static/media/USSF-90-Min-Display-Light.3d47c50e.woff";